// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.txt-width {
   /* display: block; */
   width: 350px;
}

mat-select{
   width: 30% !important;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

input {
   height: 32px;
   padding-right: 36px;
   width: 315px;
}

.input-number {
   text-align:right; 
   height: 15px; 
   padding-right: 0px;
}

mat-icon {
   width: 32px;
   height: 32px;
   line-height: 32px;
   padding: 4px;
   text-align: center;
   position: absolute;
   right: 0;
}

.icon-1 {
   margin-top: -30px;
}

.icon-2 {
   margin-top: -30px;
}
`, "",{"version":3,"sources":["webpack://./src/app/admin/add-user-company/add-user-company.component.css"],"names":[],"mappings":"AAAA;GACG,oBAAoB;GACpB,YAAY;AACf;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,YAAY;GACZ,mBAAmB;GACnB,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,YAAY;GACZ,kBAAkB;AACrB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,iBAAiB;GACjB,YAAY;GACZ,kBAAkB;GAClB,kBAAkB;GAClB,QAAQ;AACX;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,iBAAiB;AACpB","sourcesContent":[".txt-width {\n   /* display: block; */\n   width: 350px;\n}\n\nmat-select{\n   width: 30% !important;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\ninput {\n   height: 32px;\n   padding-right: 36px;\n   width: 315px;\n}\n\n.input-number {\n   text-align:right; \n   height: 15px; \n   padding-right: 0px;\n}\n\nmat-icon {\n   width: 32px;\n   height: 32px;\n   line-height: 32px;\n   padding: 4px;\n   text-align: center;\n   position: absolute;\n   right: 0;\n}\n\n.icon-1 {\n   margin-top: -30px;\n}\n\n.icon-2 {\n   margin-top: -30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
